__turbopack_context__.v({
  "button": "PreferredSourceBlock-module__s_MCtW__button",
  "text": "PreferredSourceBlock-module__s_MCtW__text",
  "title": "PreferredSourceBlock-module__s_MCtW__title",
});
